import { useState, useCallback } from 'react';
import axiosInstance from '../axiosConfig';

export function useClientSearch() {
    const [suggestions, setSuggestions] = useState([]);
    const [showSuggestions, setShowSuggestions] = useState(false);

    const searchClients = useCallback(async (name) => {
        if (name.length > 1) {
            try {
                const response = await axiosInstance.get(`/api/clients/search?name=${name}`);
                setSuggestions(response.data);
                setShowSuggestions(true);
            } catch (error) {
                console.error("Error fetching client suggestions:", error);
                setSuggestions([]);
                setShowSuggestions(false);
            }
        } else {
            setSuggestions([]);
            setShowSuggestions(false);
        }
    }, []);

    const clearSuggestions = useCallback(() => {
        setShowSuggestions(false);
    }, []);

    return { suggestions, showSuggestions, searchClients, clearSuggestions };
}
